module.exports = __webpack_public_path__ + "8b3bd4798a2d565a38a0649f2269ba2a.MP3";